<template>
  <div>
    <breadcrumb :crumbs="crumbs">
      <div class="row ls-display-flex align-items-center justify-content-end pr-15">
        <div v-if="invoices.length">
          <a class="ls-btn-primary ls-no-margin ls-xs-margin-bottom ls-xs-margin-left" @click="downloadCsv">{{ $t('contracts.main.export_csv') }}</a>
        </div>
      </div>
    </breadcrumb>
    <flash-message></flash-message>
    <filter-invoices></filter-invoices>
    <div v-if="invoices">
      <br clear="all">
      <div>
        <table class="ls-table ls-sm-space ls-table-striped" v-if="invoices.length">
          <thead>
            <tr>
              <th>{{ $t('invoices.attributes.id') }}</th>
              <th>{{ $t('invoices.attributes.customer') }}</th>
              <th>{{ $t('invoices.attributes.amount_due') }}</th>
              <th class="hidden-xs">{{ $t('invoices.attributes.created_at') }}</th>
              <th class="hidden-xs">{{ $t('invoices.attributes.due_date') }}</th>
              <th class="hidden-xs">{{ $t('invoices.attributes.paid_at') }}</th>
              <th class="hidden-xs">{{ $t('service_taxes.messages.nf') }}</th>
              <th class="hidden-xs">{{ $t('invoices.attributes.status') }}</th>
              <th></th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="(invoice, index) in invoices">
              <td>
                <strong>{{ $t('invoices.attributes.id_alias') }}:</strong> {{invoice.identifier}} <br>
                <strong>{{ $t('invoices.attributes.contract_id') }}:</strong>
                <router-link v-if="invoice.contract_id" slot="button" title=""  :to="{ name: 'contract_details', params: { id: invoice.contract_id }}">{{ invoice.contract_id}}</router-link>
                <div v-else>
                  {{ $t('invoices.attributes.contract_id_not_assigned') }}
                </div>
              </td>
              <td>{{ invoice.customer.name }}</td>
              <td>R$ {{ money.parseViewValue(invoice.amount_due) }}</td>
              <td class="hidden-xs">{{ date.parseDate(invoice.created_at) }}</td>
              <td class="hidden-xs">{{ date.parseDate(invoice.due_date) }}</td>
              <td class="hidden-xs">{{ paymentDate(invoice) }}</td>
              <td class="hidden-xs">
                <div v-if="invoice.service_tax_invoice">
                  <strong>{{ $t('service_taxes.attributes.authenticity_code') }}:</strong> <a href="#" v-on:click="openTaxInvoice(invoice.service_tax_invoice)">
                    {{ invoice.service_tax_invoice.nf_id }}
                  </a><br>
                  <strong>{{ $t('service_taxes.attributes.created_at') }}:</strong> {{ date.parseDate(invoice.service_tax_invoice.created_at) }}

                  <span v-bind:class="$t('service_taxes.tags.' + invoice.service_tax_invoice.status )">
                    {{  $t('service_taxes.attributes.statuses.' + invoice.service_tax_invoice.status )  }}
                  </span>

                </div>
                <div v-else>
                  {{ $t('service_taxes.messages.not_generated') }}
                </div>

              </td>
              <td class="hidden-xs">{{ $t('invoices.attributes.statuses.' + invoice.status) }}</td>
              <td>
                <authorized-link tag="show_invoice">
                  <router-link class="ls-btn ls-no-margin" :to="{ name: 'invoice_details', params: { invoice_id: invoice.id } }" :title="$t('application.menu.general_settings')">Detalhes</router-link>
                </authorized-link>
              </td>
            </tr>
          </tbody>
        </table>
        <div v-else role="alert">
          <empty-list></empty-list>
        </div>
        <pagination :updater="getInvoices"></pagination>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex'
import date from 'src/utils/date'
import Breadcrumb from 'src/app/components/shareds/Breadcrumb'
import money from 'src/utils/money'
import Browser from 'src/utils/browser'
import _ from 'lodash'
import Pagination from 'src/app/components/shareds/pagination/Pagination'
import Filter from './components/Filter'
import filter from 'src/utils/filter'
import EmptyList from 'src/app/components/shareds/empty-list/EmptyList'
import pdf from '../../../utils/pdf'

export default {
  name: 'ListInvoice',
  components: {
    Breadcrumb,
    Pagination,
    FilterInvoices: Filter,
    EmptyList
  },
  data () {
    return {
      money: money,
      date: date,
      crumbs: {
        'ico': 'ls-ico-origins',
        'section': this.$t('invoices.list.title')
      }
    }
  },
  methods: {
    ...mapActions(['paginateInvoices', 'consultServiceTaxInvoice', 'getCsvInvoices']),
    ...mapMutations(['clearFilterInvoices']),
    getInvoices () {
      this.$loader.show()
      var params = filter.toQueryWithPagination(this.filterInvoices, this.pagination, 10)
      this.saveOnUrl()
      this.paginateInvoices(params).then(this.$loader.hide)
    },
    getFromUrl () {
      Browser.recoverFilterFromURL(this.$route, this.filterInvoices, this.pagination)
    },
    openTaxInvoice (serviceTaxInvoice) {
      if (serviceTaxInvoice.url_invoice) {
        return window.open(serviceTaxInvoice.url_invoice)
      }
      let params = { id: serviceTaxInvoice.id }
      this.$loader.show()
      this.consultServiceTaxInvoice(params).then((response) => {
        this.afterDownload(response, serviceTaxInvoice)
      })
    },
    afterDownload (response, serviceTaxInvoice) {
      this.getInvoices()
      if (response.status === 404) {
        this.$loader.hide()
        return
      }
      let fileName = 'nf_fatura-' + serviceTaxInvoice.invoice_id + '.pdf'
      let data = response.data
      pdf.download(data, fileName)
      this.$loader.hide()
    },
    downloadCsv () {
      this.$loader.show()
      var params = filter.toQueryWithPagination(this.filterInvoices, this.pagination, 10)
      filter.toQueryWithPagination({}, this.pagination, 999)
      this.getCsvInvoices(params).then(this.afterLoad)
    },
    afterLoad () {
      this.$loader.hide()
    },
    saveOnUrl () {
      var paginationUrlParams = { current_page: this.pagination.current_page, per_page: this.pagination.per_page }
      Browser.filtersToURL(this.$router, _.merge(this.filterInvoices, paginationUrlParams), 'invoices')
    },
    closeWindow () {
      window.close()
    },
    paymentDate (invoice) {
      let paymentDate = invoice.paid_at
      if (paymentDate) {
        return date.parseDate(paymentDate)
      } else {
        return '-'
      }
    }
  },
  beforeDestroy () {
    this.clearFilterInvoices()
  },
  mounted () {
    this.getFromUrl()
    this.getInvoices()
  },
  computed: {
    ...mapGetters(['invoices', 'pagination', 'filterInvoices']),
    popup () {
      return window.name === 'popup'
    }
  },
  watch: {}
}
</script>
<style>
  .align-items-center {
    align-items: center;
  }
  .justify-content-end {
    justify-content: flex-end;
  }
  .pr-15 {
    padding-right: 15px;
  }
</style>



// WEBPACK FOOTER //
// List.vue?e926301a